// extracted by mini-css-extract-plugin
export var Section = "style-module--Section--1PEtX";
export var Heading = "style-module--Heading--KSGdB";
export var ContentWrapper = "style-module--ContentWrapper --3hm5J";